export default "__VITE_ASSET__DSPdc7ob__"